@use '@/styles/tokens' as *;

.search {
  width: 300px;

  :global(.ant-input-prefix) {
    margin-inline-end: $space-2;
  }
}

.block {
  width: 100%;
}

.icon {
  color: var(--text-primary);
}
